import { render } from "./AcademicPathwaysFinal.vue?vue&type=template&id=70a64cbc"
import script from "./AcademicPathwaysFinal.vue?vue&type=script&lang=js"
export * from "./AcademicPathwaysFinal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/holstena/Documents/GitHub/TCNJ-Home/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__